var React = require("react");
var Radio = require("./Radio.jsx");


module.exports = React.createClass({
	displayName: "RadioGroup",

	propTypes: {
		options: React.PropTypes.arrayOf(React.PropTypes.shape({
			label: React.PropTypes.string.isRequired,
			name: React.PropTypes.string.isRequired,
			checked: React.PropTypes.bool,
			disabled: React.PropTypes.bool
		})).isRequired,
		onChange: React.PropTypes.func.isRequired
	},

	change: function(name, checked) {
		var me = this, props = me.props,
			options = props.options;

		props.onChange(
			options.map(function(option) {
				
				if (option.name === name) {
					option.checked = true;
				} else {
					option.checked = false;
				}

				return option;
			})
		);
	},

	getIcon: function(idx) {
		if (idx === "1" || idx === "2") {
			return "icon-box";
		}

		return "icon-envelope-open-o";
	},

	prepareChildren: function(options, onChange, context) {
		var me = this;

		return options.map(function(child) {
			return (
				<div key={child.name} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
					{me.props.icons ? <i className={me.getIcon(child.name)} style={{fontSize: '28px'}}/> : null}
					<Radio {...child} onChange={onChange.bind(context, child.name)}/>
				</div>
			)
		});
	},

	render: function() {
		var me = this, props = me.props;

		return (
			<div style={props.style ? props.style : ''}>
				{me.prepareChildren(props.options, me.change, me)}
			</div>
		);
	}

});


// WEBPACK FOOTER //
// ./src/components/RadioGroup/RadioGroup.jsx